module.exports = __webpack_public_path__ + "img/img_covertack_flower.f93c5fe0.png";